"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("addTaelysWatermark", function($timeout, leafletTaelysWatermark) {
    return {
        restrict : "A",
        require : "obsLeafletMap",
        link : function($scope, $el, $attrs, mapCtrl) {

            var unwatch = $scope.$watch("mapConfig", function(mapConfig) {
                if(mapConfig != null) {
                    unwatch();
                    $timeout(function() {
                        addWatermark();
                    }, 1);
                }
            });

            var addWatermark = function() {
                mapCtrl.getMap().then(function(map) {
                    var watermark = new leafletTaelysWatermark();
                    map.addControl(watermark);
                });
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/presentation/addTaelysWatermark.js